import { markRaw, toRaw, type Component } from 'vue';

// This is a helper function to mark a component as raw so that it can be used in a Storybook.
// If a component is in a reactive state in Storybook, it will throw an error
// We would have to pass string component names rather than functions if we wanted to avoid this helper
type ComponentPropKey = 'icon' | 'component' | 'graphic' | 'modalComponent';

const COMPONENT_PROP_KEYS: ComponentPropKey[] = ['icon', 'component', 'graphic', 'modalComponent'];

export function markComponentRaw<T>(component: T): T {
  if (component == null || (typeof component !== 'object' && typeof component !== 'function')) {
    return component;
  }

  return markRaw(toRaw(component as object)) as T;
}

export function markItemComponentsRaw<T extends Partial<Record<ComponentPropKey, Component>>>(
  item: T,
  keys: ComponentPropKey[] = COMPONENT_PROP_KEYS
): T {
  let result: T | null = null;

  for (const key of keys) {
    const value = item[key];
    if (value != null) {
      if (!result) {
        result = { ...item };
      }
      result[key] = markComponentRaw(value);
    }
  }

  return result ?? item;
}

export function markItemsComponentsRaw<T extends Partial<Record<ComponentPropKey, Component>>>(
  items: T[],
  keys?: ComponentPropKey[]
): T[] {
  return items.map((item) => markItemComponentsRaw(item, keys));
}
